import { Flex, TextV2 } from '@withjoy/joykit';
import { ScheduleItemProps } from './ScheduleDisplay';
import React from 'react';
import { parseISO8601WithTimezone } from '@shared/components/ScheduleEditor/components/form/hooks/useGetEventTimezone';

function formatAMPM(date: Date) {
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;

  return `${hours}:${formattedMinutes} ${ampm}`;
}

const DateBadge = (props: { startTimestamp: string; endTimestamp: string }) => {
  return (
    <Flex gap="5px">
      <TextV2>{formatAMPM(new Date(props.startTimestamp))}</TextV2> - <TextV2>{formatAMPM(new Date(props.endTimestamp))}</TextV2>
    </Flex>
  );
};

export const BasicScheduleItem = (props: ScheduleItemProps) => {
  const { data } = props;
  const startTime = data.startTimeISO8601TZ && parseISO8601WithTimezone(data.startTimeISO8601TZ).datetime.toISOString();
  const endTime = data.endTimeISO8601TZ && parseISO8601WithTimezone(data.endTimeISO8601TZ).datetime.toISOString();

  return (
    <Flex
      flexDirection="column"
      marginLeft="0.75rem"
    >
      <TextV2>{data.name}</TextV2>
      {startTime && endTime && (
        <DateBadge
          startTimestamp={startTime}
          endTimestamp={endTime}
        />
      )}
      <TextV2>{data.description}</TextV2>
    </Flex>
  );
};
